module.exports = __webpack_public_path__ + "img/share_outline.3189f3cf.svg";